import React from 'react';
import { get, noop } from 'lodash';
import HomepageBL from '../../homepage/HomepageBL';
import { AdditionalBalances } from './AdditionalBalances';

export const ClearedBalance = ({
  accountDetails,
  balances,
  onFAQAnchorClick = noop,
  content = {},
}) => {
  return accountDetails.type === 'current' ||
    accountDetails.type === 'savings' ? (
    <div className="account-summary__more__balances cardsticky__hide">
      {/* account-figures*/}
      <p className="account-summary__more__balanceinfo cardsticky__hide">
        {HomepageBL.shouldShowAvailableBalance(accountDetails)
          ? get(accountDetails, 'accountDetails.overDraft') > 0
            ? content.availableBalanceWithOverdraftExpalanationText
            : content.availableBalanceExpalanationText
          : get(accountDetails, 'accountDetails.overDraft') > 0
          ? content.HCCRavailableBalanceWithOverdraftExpalanationText
          : content.HCCRavailableBalanceExpalanationText}
      </p>
      <div className="account-summary__more__balances__details">
        <AdditionalBalances
          account={accountDetails}
          balances={balances}
          onFAQAnchorClick={onFAQAnchorClick}
          content={content}
        />
      </div>
    </div>
  ) : null;
};
